import { useTranslation } from 'react-i18next';

export function FAQ() {
  const { t } = useTranslation();

  const faqs = [
    { question: t('pricing.faq1q'), answer: t('pricing.faq1a') },
    { question: t('pricing.faq2q'), answer: t('pricing.faq2a') },
    { question: t('pricing.faq3q'), answer: t('pricing.faq3a') },
    { question: t('pricing.faq4q'), answer: t('pricing.faq4a') },
    { question: t('pricing.faq5q'), answer: t('pricing.faq5a') },
    { question: t('pricing.faq6q'), answer: t('pricing.faq6a') },
  ];

  return (
    <div className="mt-20">
      <div className=" mx-auto max-w-7xl">
        <h2 className="text-3xl font-bold text-center text-white mb-6">
          {t('pricing.faqTitle')}
        </h2>
        <div className="flex flex-col gap-4">
          {faqs.map((faq) => (
            <div key={faq.question} className="tc-mv-blur p-6  ">
              <h3 className="text-lg text-white">{faq.question}</h3>
              <p className="text-white/80 mt-4">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
